import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.75 9.625C2.75 5.82794 5.8283 2.74981 9.62535 2.75C13.4222 2.75019 16.5 5.82814 16.5 9.625C16.5 13.4219 13.4222 16.4998 9.62535 16.5C5.8283 16.5002 2.75 13.4221 2.75 9.625Z",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9077 17.9075L14.6668 14.6666",
			stroke: "currentColor",
			strokeWidth: 1.46667,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
